/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Step_PaidInputs */

const en_admin_funnel_step_paid = /** @type {(inputs: Admin_Funnel_Step_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payers`)
};

/**
* | output |
* | --- |
* | "Payers" |
*
* @param {Admin_Funnel_Step_PaidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_step_paid = /** @type {((inputs?: Admin_Funnel_Step_PaidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Step_PaidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_step_paid(inputs)
});
export { admin_funnel_step_paid as "admin.funnel.step.paid" }